module.exports = require('./helpers/bundle-url').getBundleURL('2NEu2') + "logo.c51670a8.svg";